import { render, staticRenderFns } from "./input-weight-progression-table.vue?vue&type=template&id=31e95005&scoped=true&lang=pug"
import script from "./input-weight-progression-table.js?vue&type=script&lang=js&external"
export * from "./input-weight-progression-table.js?vue&type=script&lang=js&external"
import style0 from "./input-weight-progression-table.vue?vue&type=style&index=0&id=31e95005&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31e95005",
  null
  
)

export default component.exports